import { UserRoles } from "constants/userRoles";
import { LoggedInUserProfile } from "models/LoggedInUserProfile";

export const initialLoggedInUserState: LoggedInUserProfile = {
    userId: '',
    email: '',
    emailConfirmed: false,
    associatedWorkspaces: [],
    selectedWorkspace: {
        workspaceId: '',
        workspaceName: '',
        userId: '',
        userDisplayName: '',
        userPhotoUrl: undefined,
        userTagA: '',
        userTagB: '',
        userRole: UserRoles.Participant,
        userSuperiors: [],
        hasUserLessons: false,
        hasUserSubordinates: false
    },
}